import Storage from '../Store/Store'

const GlobalRequest = {
  store: Storage,
  head () {
    let head = {
      'Accept': 'application/json',
      'Content-type': 'application/json',
      'Lang': (window.localStorage.getItem('vue-lang') !== undefined) ? window.localStorage.getItem('vue-lang') : 'en',
      'timeZoneOffset': -new Date().getTimezoneOffset()
    }

    if (window.localStorage.getItem('auth') !== undefined) {
      head['Auth'] = window.localStorage.getItem('auth')
    }

    return head
  },

  get (url) {
    return this.request('GET', url)
  },

  delete (url) {
    return this.request('DELETE', url)
  },

  put (url, params) {
    return this.request('PUT', url, params)
  },

  post (url, params) {
    return this.request('POST', url, params)
  },

  sendfile (url, params) {
    return this.request('POST', url, params, true)
  },

  request (method, url, params, file) {

    return new Promise(function (resolve, reject) {
      if (this.store.main.state.visibilityState) {
        let xhr = new XMLHttpRequest()
        xhr.open(method, this.baseURL + url)

        var headers = this.head()

        for (let i in this.headers) {
          headers[i] = this.headers[i]
        }

        if (file) {
          delete headers['Content-type']
        }

        for (let i in headers) {
          xhr.setRequestHeader(i, headers[i])
        }

        xhr.onload = function () {
          var headers = xhr.getAllResponseHeaders()
          var json = headers.search(/content-type: application\/json/i) !== -1

          if (xhr.status === 200) {
            resolve({data: json ? JSON.parse(xhr.response) : xhr.response})
          } else {
            xhr.data = ( json ? JSON.parse(xhr.response) : xhr.response )
            reject(xhr)
          }
        }

        xhr.onerror = reject

        xhr.send(params)
      }
    }.bind(this))
  },

  addHeader (headers) {
    for (let i in headers) {
      this.headers[i] = headers[i]
    }
  }

}

export default GlobalRequest
